import "../../../../CardProfile/CardProfile.scss";
import money from "../../../../../../image/Company/wallet-with-card-sticking-out.png";
import deliver from "../../../../../../image/Company/fast-delivery.png";
import time from "../../../../../../image/Company/timer.png";
import verified from "../../../../../../image/Company/shield.png";
import Header from "../../../../../Header/Header";
import Footer from "../../../../../Footer/Footer";
import logo1 from "../../../../../../image/logotype/logo-1.svg";
import goodsPage from "../../../../../../image/goods.image/corn/eurosem.jpg";
import Description from '../6059/description';
import Button from "../../../../../../assets/Button/ButtonBuy/ButtonBuy"
import crumbs from "../../../../../../icons/icons8-home.svg";
import forward_arrow from "../../../../../../icons/icons-forward-arrow.png";
import { useCart } from "../../../../../cart/CartContext";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { items } from '../../../../../mockData/Sunflower-data';
import { Link } from "react-router-dom";

export default function Item() {
  const targetItemId = "26";
  const targetItem = items.find(item => item.id === targetItemId);

  const [togglefirstState, settogglefirstState] = useState(1);
  const [toggleState, setToggleState] = useState(1);
  const { add } = useCart();

  if (!targetItem) {
    return <div>Товар з вказаним id не знайдено.</div>;
  }

  const priceFirst = targetItem.priceFirst;
  const priceSecond = targetItem.priceSecond;
  const priceFourth = targetItem.priceFourth;

  const toggleTab = (index) => setToggleState(index);
  const toggleFirstTab = (index) => settogglefirstState(index);

  // --- логіка як в Item.js ---
  const parsePrice = (str) => Number(String(str).replace(/[^\d]/g, "")) || 0;

  const getActiveUnit = () => {
    const units = [
      targetItem.unitFirst,
      targetItem.unitSecond,
      targetItem.unitThird,
      targetItem.unitFourth,
    ];
    return units[togglefirstState - 1] || "";
  };

  const getActivePrice = () => {
    const prices = [priceSecond, priceFirst, priceFourth];
    return parsePrice(prices[togglefirstState - 1]);
  };

  const getActiveSku = () => {
    const skus = [
      targetItem.skuFirst,
      targetItem.skuSecond,
      targetItem.skuThird,
      targetItem.skuFourth,
    ];
    return skus[togglefirstState - 1] || targetItem.skuFirst || targetItem.sku;
  };

  const getActiveImg = () => {
    const imgs = [
      targetItem.imgFirst,
      targetItem.imgSecond,
      targetItem.imgThird,
      targetItem.imgFourth,
    ];
    return imgs[togglefirstState - 1] || targetItem.imgFirst || null;
  };

  const handleAdd = () => {
    const unit = getActiveUnit();
    const price = getActivePrice();
    const img = getActiveImg();
    const sku = getActiveSku();

    add({
      sku,
      title: targetItem.title,
      price,
      img,
      unit,
      quantity: 1,
    });
  };
  return (
    <>
      <Header />
      <Helmet>
        <meta name="keywords" content="Гібрид, соняшник, Насіння соняшнику, EUROSEM, купити, Санберрі Україна, насіння" />
        <title>Насіння соняшнику EUROSEM СУМО 007 (НС 6059) • Купити EUROSEM СУМО 007 (НС 6059) оптом і в роздріб | Sunberry Ukraine</title>
        <link rel="canonical" href="https://sun-ukr.com/evrosem-NS-6059" />
        <meta name="description" content="🌻Насіння соняшнику EUROSEM СУМО 007 (НС 6059) оптом і в роздріб ⭐ Від якісних виробника EUROSEM ✅ Замовляйте за телефоном ☎️ +38(068)-369-90-30."></meta>
      </Helmet>
      <div className="crumbs">
        <Link className="crumbs__link" to="/">
          <img className="crumbs__logo" src={crumbs} alt="crumbs" />
        </Link>
        <Link className="crumbs__link" to="catalogSeed">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Насіння</span>
        </Link>
        <Link className="crumbs__link" to="sunflowerCard">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Насіння соняшнику</span>
        </Link>
        <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
        <span className="crumbs__text">Насіння соняшнику Євросем СУМО 007 (НС 6059)</span>
      </div>
      <div className="itemSeed item--new">
        <div className="itemSeed__title">
          <h1 className="itemSeed__title--styles">Насіння соняшнику Євросем СУМО 007 (НС 6059)</h1>
        </div>
        <div className={"item__stock " + (true && "item__stock--new")}>
          <span className="item__stock-arr">
            в наявності
          </span>
          <span className="item__stock-road">
            Уточнюйте наявність
          </span>
        </div>
        <div className="itemSeed__container">
          <div className="itemSeed__left">
            <div className="test-1">
              <div className="itemSeed__image-container--slider">
                <img className="itemSeed__image" src={goodsPage} alt="goodsPage" />
              </div>
              <div className="itemSeed__center">
                <div className="itemSeed__block">
                  <div className="itemCard__logo">
                    <img className="itemCard__image-logo" src={logo1} alt="logo" />
                  </div>
                  <span className="item__factory-text">
                    Виробник:
                    <span className="item__factory-name"> Євросем</span>
                  </span>
                </div>
                <div className="characteristic__wrap">
                  <div className="aside__title">Основні характеристики</div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Період вегетації:</div>
                    <div className="characteristic__value">середньоранній (109–114 днів)</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Олійність:</div>
                    <div className="characteristic__value">50–52%</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Висота рослин:</div>
                    <div className="characteristic__value">165–185 см</div>
                  </div>
                </div>
                <div className="item__offer">
                  <div className="item__zone">
                    <div className="item__packing">
                      <span className="item__packing-text">Фасування:</span>
                      <div className="item__packing-position">
                        <div className="itemCard__capacity-tabs">
                          <button
                            className={
                              togglefirstState === 1
                                ? "itemCard__cap-tabs active-itemCard__cap-tabs"
                                : "itemCard__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(1)}
                          >
                            преміум
                          </button>
                          <button
                            className={
                              togglefirstState === 2
                                ? "itemCard__cap-tabs active-itemCard__cap-tabs"
                                : "itemCard__cap-tabs"
                            }
                            onClick={() => toggleFirstTab(2)}
                          >
                            оптимум
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="item__price">
                      <div className="price__charts">
                        <span className="price__item">Роздрібна ціна</span>
                        <div className="price__taxes">
                          <div>i</div>
                          <div class="price__taxes-content fadeInUp">
                            <span>Ціни вказані з ПДВ</span>
                          </div>
                        </div>
                      </div>
                      <div className="price item__capacity-tabs-active">
                        <div
                          className={
                            togglefirstState === 1 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceFirst}
                        </div>

                        <div
                          className={
                            togglefirstState === 2 ? "capacity  active-capacity" : "capacity"
                          }
                        >
                          {priceSecond}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item__order">
                    <Link to="order"><Button /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-cart-promo">
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={verified} alt="verified" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Якість гарантовано!</div>
              <div className="cart-promo__label _text-caption">Санберрі Україна пропонує тільки офіційну продукцію</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={time} alt="time" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Працюємо 24/7</div>
              <div className="cart-promo__label _text-caption">Ми приймаємо ваші замовлення щодня без перерв та вихідних</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={money} alt="money" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Оплата</div>
              <div className="cart-promo__label _text-caption">Пропонуємо готівковий та безготівковий розрахунки за товар</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={deliver} alt="deliver" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Доставка</div>
              <div className="cart-promo__label _text-caption">По всій Україні Новою Поштою чи іншими службами доставки</div>
            </div>
          </div>
        </div>
        <div className="seeds-tabs">
          <button
            className={toggleState === 1 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(1)}
          >
            Опис Товару
          </button>
        </div>
        <div className="seeds-tabs-active">
          <div
            className={toggleState === 1 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Description />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
